import { Server, WebSocket as WebSocketClientMock } from "mock-socket"
import { match } from "ts-pattern"
import { requestRoutesV4 } from "../fixtures/SS280506010/ws-all-routes"
import { AppVersion } from "../../app-core/_common/app-version"
import { createWsServer } from "./websocket-server-stub"

const isSSR = () => typeof window === "undefined"

let wsServer: Server | undefined = undefined
// eslint-disable-next-line @typescript-eslint/no-unused-vars
let OrigWebSocket: typeof WebSocket | undefined = undefined

export const startWebServerStub = (appVersion: AppVersion) => {
    if (isSSR() || !window.__UI_TEST__) return
    if (wsServer) return

    console.log("Start WS server")
    const requestResponseMatcher = match(appVersion)
        .with("v4", () => requestRoutesV4)
        .exhaustive()
    wsServer = createWsServer(requestResponseMatcher)

    OrigWebSocket = window.WebSocket

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.WebSocket = WebSocketStub
}

function WebSocketStub(url: string): WebSocket {
    // console.log("CREATE WS STUB", url)
    // return url.includes("3001") ? new WebSocketClientMock(url) : new OrigWebSocket(url)
    return new WebSocketClientMock(url)
}
